export default __webpack_public_path__ + "static/media/g.0fd00f49.png";